import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from '@/i18n'
import './style.css'
import CryptoJS from 'crypto-js'
import { api, NODE_BASE } from '@/api/http'
import { useThemeStore } from '@/stores/themeStore'

const app = createApp(App)

app.config.globalProperties.$http = api   // 공용 인스턴스 — 토큰 헤더·401 로그아웃 인터셉터를 같이 탄다
app.config.globalProperties.$CryptoJS = CryptoJS
app.config.globalProperties.URL = NODE_BASE

app.use(createPinia())
useThemeStore().init()
app.use(router)
app.use(i18n)
app.mount('#app')
